import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { productCategoryList } from "constants/productCategories";

//get all product-category list
export const getProductCategoryList = async (
  dispatch,
  { pageNum, filters = null } = {},
) => {
  try {
    const res = await api.product_category_list(pageNum, filters);
    dispatch({ type: productCategoryList, payload: res.data });
  } catch (error) {
    dispatch({
      type: productCategoryList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};
//add product categories
export const addProductCategory = async (bodyData) => {
  try {
    const res = await api.add_product_category(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
//edit
export const editProductCategory = async (id, bodyData) => {
  try {
    const res = await api.edit_product_category(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
